import { all, fork, put, takeEvery, takeLatest, call, delay } from "redux-saga/effects"
import { getItems } from "util/localStorage"
import * as actionTypes from "appRedux/actions/setup/propertyInfo/PropertyActionType"
import * as actionCreators from "appRedux/actions/setup/propertyInfo"
import { userSignOut } from "appRedux/actions/Auth"
import { APIGetRequest, APIPostRequest } from "util/connection"
import { API_URL_V1, API_PMS_HEADERS } from "constants/ApiSetting"
import { ApiResponse } from "constants/ActionTypes"
import { dataSourceType, initialPropertyDefaultData } from "appRedux/reducers/setup/propertyInfo"

function* propertyPreviewProcess() {
  const { access_token } = yield call(getItems, ['access_token'])
  const AccessToken = access_token
  const url = `${API_URL_V1}pms/masterfile/propertyinfo/`
  API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
  try {
    const response: ApiResponse = yield APIGetRequest(url, API_PMS_HEADERS)
    if (response.status === 200) {
      const propertyDataSource = response.data
      /* if no error put everything to reducer */
      yield put(actionCreators.propertyDataSourceSuccess(propertyDataSource))
      yield delay(100)

    } else {
      /* Show error message and signout */
      const { message } = response.data
      const processStatus = { status: false, action: "propertyPreview", message }
      yield put(actionCreators.propertyDataSourceSuccess(initialPropertyDefaultData))
      yield delay(100)
      yield put(actionCreators.propertyProcessSuccess(processStatus))
      yield delay(100)
      yield put(actionCreators.propertyProcessReset())
      if (response.status === 403) {
        yield put(userSignOut())
      }
    }

  } catch (error) {
    const processStatus = { status: false, action: "propertyPreview", message: error }
    yield put(actionCreators.propertyDataSourceSuccess(initialPropertyDefaultData))
    yield delay(100)
    yield put(actionCreators.propertyProcessSuccess(processStatus))
    yield delay(100)
    yield put(actionCreators.propertyProcessReset())
  }

}

function* propertyUpdateProcess({ payload }: actionTypes.PropertyUpdate) {

  const { newUpload } = payload

  let propertyInfo = {} as dataSourceType
  propertyInfo.prop_id = payload.prop_id
  propertyInfo.prop_name = payload.prop_name
  propertyInfo.company = payload.company
  propertyInfo.address1 = payload.address1
  propertyInfo.address2 = payload.address2
  propertyInfo.address3 = payload.address3
  propertyInfo.address4 = payload.address4
  propertyInfo.email = payload.email
  propertyInfo.telephone = payload.telephone
  propertyInfo.fax = payload.fax
  propertyInfo.website = payload.website
  if (newUpload) {
    const dataSplit = payload.logo.split(",")
    const [type, image] = dataSplit
    propertyInfo.logo = image
    propertyInfo.logo_type = type
  }
  /* 
  Example of mock process
  const generateMockProcessStatus = () => {
    const status = Math.random() >= 0.5 ? true : false
    const message = status ? "Test success" : "Test failed"
    return { status, action: "propertyUpdate", message }
  }
  const processStatus = generateMockProcessStatus()
  yield delay(2000)
  yield put(actionCreators.propertyProcessSuccess(processStatus))
  */
  try {
    const { access_token } = yield call(getItems, ['access_token'])
    const AccessToken = access_token
    const url = `${API_URL_V1}pms/masterfile/propertyinfo/update/`
    API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
    const API_DATABODY = propertyInfo
    const response: ApiResponse = yield APIPostRequest(url, API_DATABODY, API_PMS_HEADERS)

    if (response.status === 200) {
      const { result_code, result_msg } = response.data
      const processStatus = { status: result_code === "0", action: "propertyUpdate", message: result_msg || "" }
      yield put(actionCreators.propertyProcessSuccess(processStatus))
      yield delay(200)
      yield put(actionCreators.propertyProcessReset())
      
    } else {
      const { message } = response.data
      const processStatus = { status: false, action: "propertyUpdate", message }
      yield put(actionCreators.propertyProcessSuccess(processStatus))
      yield delay(100)
      yield put(actionCreators.propertyProcessReset())
      if (response.status === 403) {
        yield put(userSignOut())
      }
    }

  } catch (error) {
    const processStatus = { status: false, action: "propertyUpdate", message: error }
    yield put(actionCreators.propertyProcessSuccess(processStatus))
    yield delay(100)
    yield put(actionCreators.propertyProcessReset())
  }
}

/* Watcher Saga */
export function* propertyPreview() {
  yield takeLatest(actionTypes.PROPERTY_PREVIEW, propertyPreviewProcess)
}

export function* propertyUpdate() {
  yield takeEvery(actionTypes.PROPERTY_UPDATE, propertyUpdateProcess)
}


export default function* rootSaga() {
  yield all([fork(propertyPreview),
  fork(propertyUpdate)])


}
